export const SHOW_ALL_LAYOUT = {
  list: {
    marginTop: 10,
  },
  header: { marginBottom: 26, marginTop: 16, marginVerticalMobile: 18, },
};
